export const comparisonUrlParam = "comparison";
export const comparisonMultiUrlParam = "comparisonMulti";
export const dimensionsUrlParam = "dimensions";
export const connectUrlParam = "connect";
export const providerTypeUrlParam = "providerType";
export const regionUrlParam = "region";
export const organizationIdUrlParam = "organizationId";
export const sectionSplitUrlParam = "sectionSplit";
export const distributionLevel1UrlParam = "distributionLevel1";
export const distributionLevel2UrlParam = "distributionLevel2";
export const optionIdUrlParam = "optionId";
export const trendIntervalUrlParam = "trendInterval";
export const yearUrlParam = "year";
export const episodeUrlParam = "episode";
export const timeRangeUrlParam = "timeRange";
export const subpageUrlParam = "subpage";

export const allAllowedUrlParams = [
    comparisonUrlParam,
    comparisonMultiUrlParam,
    dimensionsUrlParam,
    connectUrlParam,
    providerTypeUrlParam,
    regionUrlParam,
    organizationIdUrlParam,
    sectionSplitUrlParam,
    distributionLevel1UrlParam,
    distributionLevel2UrlParam,
    optionIdUrlParam,
    trendIntervalUrlParam,
    yearUrlParam,
    episodeUrlParam,
    timeRangeUrlParam,
    subpageUrlParam,
];
